import axios from 'axios';

export const invoiceTxnService = {
    createInvoiceTxnService: (invoiceId, body) => axios.post(`/invoice-txn/${invoiceId}`, body, { auth: true }),

    voidInvoiceTxnService: (txnId, body) => axios.post(`/invoice-txn/${txnId}/void`, body, { auth: true }),

    getInvoiceTxnsService: (invoiceId, params) => axios.get(`/invoice-txn/${invoiceId}`, { auth: true, params: params }),
};
